export default __webpack_public_path__ + "static/aboutus-cb963d1abcd1389f5fd2e51593b8ad55.png";